import { useQuery } from '@tanstack/react-query';

import type { InFieldLocationConfig } from '@cognite/apm-client';

import { useFDMServices } from '../../../../providers/fdm-services/fdm-services.context';
import { QueryKeys } from '../../../../utils/queryKeys';

export interface UseInFieldLocationConfigReturn {
  data: InFieldLocationConfig | undefined;
  isLoading: boolean;
  isPending: boolean;
}

export const useInFieldLocationConfig = (
  rootLocationExternalId?: string
): UseInFieldLocationConfigReturn => {
  const { apmClient } = useFDMServices();

  const useInFieldLocationResults = useQuery<
    InFieldLocationConfig | null,
    Error
  >({
    queryKey: [
      QueryKeys.INFIELD_LOCATION_CONFIG,
      rootLocationExternalId ?? 'undefined',
    ],
    queryFn: async () => {
      if (!rootLocationExternalId) {
        return null;
      }

      const response = await apmClient.infieldLocationConfig.list(
        `
      externalId
      rootLocationExternalId
      appInstanceSpace
      featureToggles
    `,
        {
          filters: {
            equals: {
              property: 'rootLocationExternalId',
              eq: rootLocationExternalId,
            },
          },
        }
      );
      return response.list.items[0] || null;
    },
  });
  return {
    data: useInFieldLocationResults.data ?? undefined,
    isLoading: useInFieldLocationResults.isLoading,
    isPending: useInFieldLocationResults.isPending,
  };
};
